import { render, staticRenderFns } from "./accurate-study.vue?vue&type=template&id=71ef2e67&scoped=true"
import script from "./accurate-study.vue?vue&type=script&lang=js"
export * from "./accurate-study.vue?vue&type=script&lang=js"
import style0 from "./accurate-study.vue?vue&type=style&index=0&id=71ef2e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef2e67",
  null
  
)

export default component.exports